import {JsonApiResponse} from '@tisa-group/cdk';
import {UmpireStandings} from '@tisa-group/models';
import {Injectable} from '@angular/core';
import {Action, createSelector, State, StateContext} from '@ngxs/store';
import {StandingsService} from '@tisa-group/core';
import {LoadStandings} from '@store/standings/standings.actions';
import {tap} from 'rxjs';
import {patch} from '@ngxs/store/operators';

export type StandingsStateModel = Record<string, JsonApiResponse<UmpireStandings>>;

@State<StandingsStateModel>({
  name: 'standings',
  defaults: {},
})
@Injectable()
export class StandingsState {
  @Action(LoadStandings)
  loadStandings(ctx: StateContext<StandingsStateModel>, action: LoadStandings) {
    const stateStandings = ctx.getState()[action.groupId];

    if (stateStandings) {
      return stateStandings;
    }

    return this.standingsService
      .fetch(action.groupId, {
        filter: {id: {value: action.groupId, rule: 'eq'}},
        include: [
          'stage',
          'squads',
          'squads.club_image',
          'squads.team',
          'squads.team.club',
        ].join(','),
      })
      .pipe(tap(res => ctx.setState(patch({[action.groupId]: res}))));
  }

  static getStandingsByGroupId(
    groupId: string,
  ): (state: StandingsStateModel) => UmpireStandings {
    return createSelector<(state: StandingsStateModel) => UmpireStandings>(
      [StandingsState],
      state => {
        return state[groupId]?.data;
      },
    );
  }

  constructor(readonly standingsService: StandingsService) {}
}
